export const useEnvBoolean = (value: unknown): boolean => {
  return String(value).toLowerCase() === "true";
};
